/*
 * Zampe & Cuori — Newsletter → Klaviyo
 * ------------------------------------------------------------
 * Intercetta l'invio dei form newsletter renderizzati in
 * "modalità Klaviyo" (snippets/newsletter-form.liquid) e li
 * iscrive alla lista via API client di Klaviyo.
 *
 * Ogni form porta con sé:
 *   data-zc-newsletter="klaviyo"     → selettore del form
 *   data-klaviyo-list="<LIST_ID>"    → lista di destinazione
 *
 * Il company_id (public id) arriva da window.ZC_KLAVIYO,
 * impostato in layout/theme.liquid dai settings del tema.
 *
 * Doc: https://developers.klaviyo.com/en/reference/create_client_subscription
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  var config = window.ZC_KLAVIYO || {};
  var companyId = config.companyId;
  if (!companyId) return; // Klaviyo non configurato: non fare nulla

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId);
  var REVISION = '2026-04-15';

  var MESSAGES = {
    success: 'Grazie per esserti iscritto alla newsletter! 🐾❤️',
    invalid: 'Inserisci un indirizzo email valido.',
    error: 'Ops, qualcosa non ha funzionato. Riprova tra poco.'
  };

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setFeedback(form, message, isError) {
    var el = form.querySelector('[data-zc-newsletter-feedback]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('zc-newsletter-form__feedback--error', isError === true);
  }

  function buildPayload(email, listId, source) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
  }

  function subscribe(form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var listId = form.getAttribute('data-klaviyo-list');
    var email = input ? input.value.trim() : '';
    var source = form.id && form.id.indexOf('Footer') === 0 ? 'Newsletter footer' : 'Newsletter home';

    if (!EMAIL_RE.test(email)) {
      setFeedback(form, MESSAGES.invalid, true);
      if (input) input.focus();
      return;
    }

    if (!listId) {
      setFeedback(form, MESSAGES.error, true);
      return;
    }

    if (button) button.disabled = true;

    fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify(buildPayload(email, listId, source))
    })
      .then(function (response) {
        if (response.status === 202 || response.ok) {
          setFeedback(form, MESSAGES.success, false);
          form.reset();
        } else {
          setFeedback(form, MESSAGES.error, true);
        }
      })
      .catch(function () {
        setFeedback(form, MESSAGES.error, true);
      })
      .then(function () {
        if (button) button.disabled = false;
      });
  }

  // Delega sul document: cattura entrambi i form (home + footer),
  // anche se ricaricati dal theme editor.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[data-zc-newsletter="klaviyo"]')) {
      event.preventDefault();
      subscribe(form);
    }
  });
})();
